import { Typography, useTheme } from "@mui/material";
import { debounce } from "lodash";
import { setTableCaption } from "../../context/DataTableReducer";
import useDataTableContext from "../../context/useDataTableContext";
import EditableContent from "../DataTableContainer/Components/DataTableBody/Components/EditableContent";

const DataTableCaption = () => {
    const { state, dispatch } = useDataTableContext();
    const { caption, readOnly } = state;

    const theme = useTheme();

    const onChange = (value: string | null) => {
        dispatch(setTableCaption(value || ""));
    };

    const onChangeDebounced = debounce((value: string) => onChange(value), 500);

    if (readOnly) {
        return caption ? (
            <div className="ce-block flex">
                <div suppressContentEditableWarning={true} dangerouslySetInnerHTML={{ __html: caption }} />
            </div>
        ) : null;
    }

    return (
        <div className="ce-block flex min-h-5">
            <Typography
                variant={"caption"}
                component={EditableContent}
                contentEditable
                sx={{ flex: 1, p: 0, m: theme.spacing(0.5, 0.5, 2), display: "inline-block" }}
                suppressContentEditableWarning={true}
                onInput={(e) => onChangeDebounced(e.currentTarget.innerHTML)}
                dangerouslySetInnerHTML={{ __html: caption || "" }}
                data-edit-placeholder="Table caption..."
            />
        </div>
    );
};

export default DataTableCaption;
